import {Breadcrumbs, FormDialog, Title} from '@management-ui/core';
import {Add} from '@mui/icons-material';
import {Box, Button} from '@mui/material';
import {reverse} from 'named-urls';
import React, {useCallback, useState} from 'react';
import {useHistory} from 'react-router-dom';
import TableHolder from '../../../../components/TableHolder';
import routes from '../../../../routes';
import PurchaseOrderForm from '../../forms/PurchaseOrderForm';
import Table from './Table';

const PurchaseOrders = ({archive = false}) => {
  const history = useHistory();
  const [showNew, setShowNew] = useState(false);

  const goToDetail = useCallback((order) => {
    history.push(reverse(order.archived ? routes.archive.purchaseOrder.detail : routes.purchaseOrders.detail, {id: order.id}));
  }, [history]);

  return (
    <div>
      <Breadcrumbs crumbs={[{title: 'Purchase Orders'}]}/>
      <Title title="Purchase Orders">
        <Box display="flex" flex={1} justifyContent="flex-end">
          <Button variant="contained" startIcon={<Add/>} onClick={() => setShowNew(true)} color="success">
            Add New Purchase Order
          </Button>
        </Box>
      </Title>
      <TableHolder>
        <Table archive={archive}/>
      </TableHolder>
      <FormDialog
        title="Add New Purchase Order"
        open={showNew}
        onClose={() => setShowNew(false)}
        maxWidth="md"
        render={(props) => (
          <PurchaseOrderForm
            {...props}
            order={{}}
            fields="core"
            onSaved={goToDetail}/>
        )}
      />
    </div>
  );
}

export default PurchaseOrders;
